import React, { useEffect, useState } from 'react'
import CommissionForm from './CommissionForm/CommissionForm';
import "./Commission.css";

const Commission = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
    });

    const [activeTab, setActiveTab] = useState("photographer");

    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;

            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);

        return () => clearInterval(interval);
    }, [isSidebarOpen]);

    const tabs = [
        { id: "photographer", label: "Photographer", role: "photographers", title: "Photographer" },
        { id: "videographer", label: "Videographer", role: "videographers", title: "Videographer" },
        { id: "lightning", label: "Lighning Setup", role: "lighningSetups", title: "Lighning Setup" },
        { id: "editor", label: "Editor", role: "editors", title: "Editor" },
    ];

    return (
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
                }`}
            style={{ marginTop: "100px" }}
        >
            <div className="page-inner-wrapper">
                <h2 className="page-title">Commission</h2>

                {/* Tabs */}
                <div className="custom-tabs">
                    {tabs.map((tab) => (
                        <div
                            key={tab.id}
                            className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>

                {/* Form based on active tab */}
                {tabs.map((tab) => (
                    activeTab === tab.id && (
                        <CommissionForm 
                            key={tab.id}
                            role={tab.role} 
                            roleTitle={tab.title} 
                        />
                    )
                ))}
            </div>
        </div>
    )
}

export default Commission